<template>
  <b-row class="admin-customers-row mx-0 mt-5">
    <b-col
      md="12"
      xl="12"
      lg="12"
      :style="{padding: '1.25rem'}"
      class="handover-card-column d-flex"
    >
      <b-col cols="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Customer name</h6>
      </b-col>
      <b-col cols="2" class="">
        <h6 class="font-sm primary--text font-family-medium">
          Subscription type
        </h6>
      </b-col>
      <b-col cols="2" class="">
        <h6 class="font-sm primary--text font-family-medium">Company Name</h6>
      </b-col>
      <b-col cols="3">
        <h6 class="font-sm primary--text font-family-medium">Assigned To</h6>
      </b-col>
      <b-col class="" cols="2">
        <h6 class="font-sm primary--text font-family-medium">Date</h6>
      </b-col>
      <b-col class="d-flex" cols="1">
        <h6 class="font-sm primary--text font-family-medium">Actions</h6>
      </b-col>
    </b-col>

    <div class="w-100">
      <b-col
        v-for="item in archivedCustomersList"
        :key="item.id"
        md="12"
        xl="12"
        lg="12"
        class="px-0 py-2 handover-card-column"
      >
        <b-card
          @click="navigate(item)"
          @mouseenter="showCardHover(item.id)"
          @mouseleave="undoCardHover(item.id)"
          no-body
        >
          <b-card-body class="py-4 d-flex align-items-center">
            <b-col cols="2" class="d-flex align-items-center">
              <b-avatar
                v-if="item.user.avatarThumbnail"
                size="4.4rem"
                :src="item.user.avatarThumbnail"
              ></b-avatar>
              <b-avatar
                class="customer-avatar bg--primary"
                v-else
                size="4.4rem"
                :text="userInitials(item.user)"
              ></b-avatar>
              <h6 :title="`${item.user.firstName} ${item.user.lastName}`"
                class="font-sm font-family-medium primary--text pl-3  reduce-line-height"
              >
                {{ ellipsify(`${item.user.firstName} ${item.user.lastName}`, 25) }}
              </h6>
            </b-col>
            <b-col cols="2" class="">
              <h6
                class="font-sm primary--text font-weight-normal text-capitalize"
              >
                {{ getCompanyMembership(item) }}
              </h6>
            </b-col>
            <b-col cols="2" class="">
              <h6
                class="font-sm primary--text font-weight-normal reduce-line-height"
              >
                {{ getCompanyName(item) }}
              </h6>
            </b-col>
            <b-col
              cols="3"
              v-if="item.assignedAssistants.length > 0"
              class="d-flex align-items-center "
            >
              <b-avatar
                size="4.4rem"
                :src="item.assignedAssistants[0].avatarThumbnail"
                v-if="item.assignedAssistants[0].avatarThumbnail"
              ></b-avatar>
              <b-avatar
                size="4.4rem"
                class="pa-avatar bg--primary"
                v-else
                :text="item.assignedAssistants[0].assistantInitials"
              ></b-avatar>
              <div class="d-flex flex-column">
                <h6
                  class="font-sm primary--text font-family-medium reduce-line-height pl-3"
                >
                  {{
                    `${item.assignedAssistants[0].firstName} ${item.assignedAssistants[0].lastName}`
                  }}
                </h6>
                <span
                  class="primary--text font-weight-normal pl-3"
                  v-if="item.assignedAssistantsCount > 1"
                  >+
                  {{ item.assignedAssistantsCount - 1 }}
                  more</span
                >
              </div>
            </b-col>
            <b-col
              cols="3"
              v-if="item.assignedAssistants.length === 0"
              class="d-flex align-items-center "
            >
              <h6 class="font-sm primary--text ml-2 mt-3">N/A</h6>
            </b-col>
            <b-col class="" cols="2">
              <h6 class="font-sm primary--text">
                {{
                  item.customerProfile.created
                    ? getFormattedDate(item.customerProfile.created)
                    : "N/A"
                }}
              </h6>
            </b-col>
            <b-col class="d-flex " cols="1" :style="{ padding: '0' }">
              <div
                @click.stop="showUnarchiveModal(item)"
                v-if="
                  !archiveHover ||
                    (showInactiveArchiveHover &&
                      activeUnarchiveHoverId !== item.id)
                "
                class="empty-icon-avatar d-flex align-items-center justify-content-center"
              >
                <img
                  class="cursor-pointer"
                  src="@/assets/icons/arrow_down_square.svg"
                  alt
                />
              </div>
              <div
                class="archive-hover-avatar position-relative d-flex align-items-center justify-content-center"
                v-if="archiveHover && activeUnarchiveHoverId === item.id"
                @click.stop="showUnarchiveModal(item)"
              >
                <img src="@/assets/icons/arrow_down_square_hover.svg" alt="" />
              </div>

              <div
                v-if="
                  !deleteHover ||
                    (showInactiveDeleteHover && activeDeleteHoverId !== item.id)
                "
                @click.stop="showDeleteModal(item)"
                class="empty-icon-avatar d-flex align-items-center justify-content-center"
              >
                <img
                  class="cursor-pointer"
                  src="@/assets/icons/card_delete.svg"
                  alt
                />
              </div>
              <div
                class="delete-hover-avatar position-relative d-flex align-items-center justify-content-center"
                v-if="deleteHover && activeDeleteHoverId === item.id"
                @click.stop="showDeleteModal(item)"
              >
                <img src="@/assets/icons/card_delete_hover.svg" alt="" />
              </div>
            </b-col>
          </b-card-body>
        </b-card>
      </b-col>
      <infinite-loading
        spinner="spiral"
        :identifier="archivedCustomersId"
        @infinite="infiniteHandlerArchivedCustomers"
        ><div slot="no-more">
          <h4 class="font-md primary--text font-family-medium mt-5 mb-5">
            No more customers to load.
          </h4>
        </div>
        <div slot="no-results">
          <h4 class="font-md primary--text font-family-medium mt-5 mb-5">
            No more customers to load.
          </h4>
        </div></infinite-loading
      >
    </div>
    <!-- Unarchive Modal -->
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showUnarchive"
      v-if="showUnarchive"
    >
      <b-container fluid>
        <b-button
          @click="closeModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 pl-4 d-flex flex-column">
          <h2 v-if="isCustomerUnarchived" class="modal_header ml-4 font-md">
            Successfully unarchived
          </h2>
          <h4
            v-if="!isCustomerUnarchived"
            class="font-md subtext mb-4 mt-3 ml-4"
          >
            Do you want to unarchive the following profile?
          </h4>
          <h4 v-else class="font-md subtext mb-4 mt-1 ml-4">
            Following customer has been successfully unarchived.
          </h4>
        </b-row>
        <b-row align-v="center" class="pr-2">
          <b-col class="flex-row d-flex mb-4">
            <div>
              <b-avatar
                v-if="selectedCustomerAvatar"
                :src="selectedCustomerAvatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="selectedCustomerInitials"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div
              class="d-flex flex-column justify-content-center position-relative ml-4"
            >
              <p class="font-family-medium primary--text mt-2">
                {{ selectedCustomerFullName }}
              </p>
              <p class="secondary--text reduce-whitespace">
                {{ selectedCustomerEmail }}
              </p>
            </div>
          </b-col>
          <b-button
            @click="unarchiveCustomer"
            v-if="!isCustomerUnarchived"
            class="px-5 py-3 btn-pill reduce-whitespace btn-primary"
          >
            <b-spinner
              v-if="isSavingUnarchive"
              style="width: 14px; height: 14px"
              variant="light"
              label="Spinning"
            ></b-spinner>
            {{ `${isSavingUnarchive ? "" : unarchiveBtnText}` }}
          </b-button>
        </b-row>
        <b-row>
          <div v-if="showUnArchiveErrorMsg">
            <h6
              class="pt-2 pl-4 font-sm font-family-regular danger position-relative"
            >
              {{ UnArchiveErrorMsg }}
            </h6>
          </div>
        </b-row>
      </b-container>
    </b-modal>
    <!-- End unarchive modal -->
    <!-- Show delete modal -->
    <b-modal
      centered
      body-class="delete-modal"
      hide-footer
      hide-header
      no-close-on-backdrop
      no-close-on-esc
      v-model="showDelete"
      v-if="showDelete"
    >
      <b-container fluid>
        <b-button
          @click="closeDeleteModal"
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <b-row class="pt-2 d-flex flex-column" :style="{ paddingLeft: '15px' }">
          <h2
            v-if="!isCustomerDeleted"
            class="modal_header font-md"
            :style="{ marginBottom: 0 }"
          >
            Are you sure?
          </h2>
          <h2 v-if="isCustomerDeleted" class="modal_header font-md">
            Successfully deleted
          </h2>
          <h4 v-if="!isCustomerDeleted" class="font-md subtext">
            Do you want to delete the following Customer?
          </h4>
          <h4 v-else class="font-md subtext">
            Following Customer has been successfully deleted.
          </h4>
        </b-row>
        <b-row align-v="center">
          <b-col class="flex-row d-flex pb-4" cols="7">
            <div :style="{ paddingRight: '10px' }">
              <b-avatar
                v-if="selectedCustomerAvatar"
                :src="selectedCustomerAvatar"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
              <b-avatar
                v-else
                :text="selectedCustomerInitials"
                size="8rem"
                class="pa-avatar bg--primary"
              ></b-avatar>
            </div>
            <div class="d-flex flex-column position-relative ml-4">
              <p class="font-family-medium primary--text">
                {{ selectedCustomerFullName }}
              </p>
              <p class="secondary--text reduce-whitespace">
                {{ selectedCustomerEmail }}
              </p>
              <div class="d-flex reduce-whitespace-2">
                <b-button
                  class="text-uppercase btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                  >{{ getCompanyMembership(selectedCustomer) }}</b-button
                >
              </div>
            </div>
          </b-col>
          <b-col :style="{textAlign: 'center'}" cols="5">
            <b-button
              @click="deleteCustomer"
              v-if="!isCustomerDeleted"
              class="btn-danger px-4 py-3 btn-pill reduce-whitespace"
            >
              <b-spinner
                v-if="isSavingDelete"
                style="width: 14px; height: 14px"
                variant="light"
                label="Spinning"
              ></b-spinner>
              {{ `${isSavingDelete ? "" : deleteBtnText}` }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <!-- End delete modal -->
  </b-row>
</template>

<script>
import moment from "moment";
import {
  archiveOrDeleteAccount,
  getAllArchivedOrDeletedAccounts,
  getArchivedCustomers,
  unarchiveCustomerAccount
} from "@/apis/customers";
import { ellipsify } from "@/utils/utils";
export default {
  name: "CurrentCustomers",
  props: [
    "selectedSubscriptionId",
    "filteredCustomerId",
    "selectedCompanyId"
  ],
  data() {
    return {
      expandHover: false,
      archiveHover: false,
      deleteHover: false,
      showUnArchiveErrorMsg: false,
      UnArchiveErrorMsg: "",
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true,
      activeUnarchiveHoverId: "",
      inactiveUnarchiveHoverId: "",
      showInactiveArchiveHover: true,
      activeDeleteHoverId: "",
      inactiveDeleteHoverId: "",
      showInactiveDeleteHover: true,
      showUnarchive: false,
      showDelete: false,
      selectedCustomerFullName: "",
      selectedCustomerEmail: "",
      selectedCustomerAvatar: "",
      selectedCustomerInitials: "",
      selectedCustomer: null,
      isSavingUnarchive: false,
      isCustomerUnarchived: false,
      isSavingDelete: false,
      isCustomerDeleted: false,
      unarchiveBtnText: "Unarchive",
      deleteBtnText: "Confirm Delete",
      isDelete: null,
      isAccountDeleted: null,
      archivedCustomersId: new Date(),
      offsetArchivedCustomer: 0,
      archivedCustomersList: []
    };
  },
  methods: {
    ellipsify,
    changeType() {
      this.archivedCustomersList = [];
      this.offsetArchivedCustomer = 0;
      this.archivedCustomersId += 1;
    },
    getCompanyMembership(customer){
      return customer.customerProfile.membership
        ? customer.customerProfile.membership.title
        : "N/A";
    },
    getCompanyName(customer) {
      return customer.customerProfile.company
        ? customer.customerProfile.company.name
        : "N/A";
    },
    getCreatedAt(customer) {
      return customer.customerProfile.created
        ? this.getFormattedDate(customer.customerProfile.created)
        : "N/A";
    },
    infiniteHandlerArchivedCustomers($state) {
      let data = {
        membership: this.selectedSubscriptionId,
        id: this.filteredCustomerId,
        company: this.selectedCompanyId
      };
      getArchivedCustomers(30, this.offsetArchivedCustomer, data).then(res => {
        this.archivedCustomersList = [
          ...this.archivedCustomersList,
          ...res.data.results
        ];
        this.offsetArchivedCustomer = res.data.offset;
        if (res.data.next === null) {
          $state.complete();
        } else {
          $state.loaded();
        }
      });
    },
    navigate(item) {
      if (!item.isProfileIntakeSubmitted) {
        this.$router.push({
          name: "ClientIntake",
          params: {
            profileId: item.id
          }
        });
      } else {
        this.$router.push({
          name: "CustomerDetails",
          params: {
            profileId: item.id
          },
          query: {
            tab: 2
          }
        });
      }
    },
    userInitials(user) {
      let initials = `${user.firstName.split(" ")[0]} ${user.lastName}`;
      return initials.match(/\b(\w)/g).join("");
    },
    getFormattedDate(date) {
      return moment(date).format("MM/DD/YYYY");
    },
    showUnarchiveModal(profile) {
      let { user } = profile;
      this.selectedCustomer = profile;
      this.selectedCustomerFullName = `${user.firstName} ${user.lastName}`;
      this.selectedCustomerInitials = this.selectedCustomerFullName
        .match(/\b(\w)/g)
        .join("");
      this.showUnarchive = true;
      this.selectedCustomerEmail = user.email;
      this.selectedCustomerAvatar = user.avatarThumbnail;
      this.getArchivedAccounts();
      this.showUnArchiveErrorMsg = false;
    },
    showDeleteModal(profile) {
      let { user } = profile;
      this.selectedCustomer = profile;
      this.selectedCustomerFullName = `${user.firstName} ${user.lastName}`;
      this.selectedCustomerInitials = this.selectedCustomerFullName
        .match(/\b(\w)/g)
        .join("");
      this.showDelete = true;
      this.selectedCustomerEmail = user.email;
      this.selectedCustomerAvatar = user.avatarThumbnail;
      this.getArchivedAccounts();
    },
    getArchivedAccounts() {
      getAllArchivedOrDeletedAccounts().then(res => {
        let getArchiveDeleteForCurrentProfile = res.data.results.filter(
          item => item.profile === this.activeUnarchiveHoverId
        );
        if (getArchiveDeleteForCurrentProfile.length > 0) {
          this.customerIdToUnarchive = getArchiveDeleteForCurrentProfile[0].id;
          this.isDelete = res.data.results
            .filter(item => {
              if (
                item.profile === this.activeUnarchiveHoverId &&
                !item.isDelete
              ) {
                return (
                  item.profile === this.activeUnarchiveHoverId &&
                  item.isDelete === false
                );
              }
            })
            .map(i => i.isDelete)[0];
          this.isAccountDeleted = res.data.results
            .filter(item => {
              if (item.profile === this.activeDeleteHoverId && item.isDelete) {
                return (
                  item.profile === this.activeDeleteHoverId &&
                  item.isDelete === true
                );
              }
            })
            .map(i => i.isDelete)[0];
        }
      });
    },
    unarchiveCustomer() {
      this.isSavingUnarchive = true;
      this.showUnArchiveErrorMsg = "";
      unarchiveCustomerAccount(this.customerIdToUnarchive)
        .then(() => {
          this.isCustomerUnarchived = true;
          this.isSavingUnarchive = false;
          this.archivedCustomersList = this.archivedCustomersList.filter(
            item => item !== this.selectedCustomer
          );
        })
        .catch(err => {
          this.isSavingUnarchive = false;
          this.showUnArchiveErrorMsg = true;
          this.UnArchiveErrorMsg = err.response.data.detail;
        });
    },
    deleteCustomer() {
      this.isSavingDelete = true;
      const data = {
        profile: this.activeDeleteHoverId,
        isDelete: true
      };
      archiveOrDeleteAccount(data)
        .then(() => {
          this.isCustomerDeleted = true;
          this.archivedCustomersList = this.archivedCustomersList.filter(
            item => item !== this.selectedCustomer
          );
        })
        .catch(err => {
          console.log(err);
          this.isSavingDelete = false;
        })
        .finally(() => {
          this.isSavingDelete = false;
        });
    },
    closeDeleteModal() {
      this.showDelete = false;
      this.isCustomerDeleted = false;
    },
    closeModal() {
      this.showUnarchive = false;
      this.isCustomerUnarchived = false;
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
      this.activeUnarchiveHoverId = id;
      this.archiveHover = true;
      this.showInactiveArchiveHover = true;
      this.activeDeleteHoverId = id;
      this.deleteHover = true;
      this.showInactiveDeleteHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
      this.inactiveUnarchiveHoverId = id;
      this.archiveHover = false;
      this.inactiveDeleteHoverId = id;
      this.deleteHover = false;
    }
  }
};
</script>

<style scoped lang="scss">
.relative-right {
  right: 0.3rem;
}
.relative-top {
  top: 0.3rem;
}
.actions-header {
  margin-left: -2.5rem;
}
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
.card {
  cursor: pointer;
}
::v-deep .delete-modal.modal-body {
  padding: 2rem;
  h4.subtext {
    padding-bottom: 2.5rem;
  }
}

</style>
